export default __webpack_public_path__ + "static/ServicePro-67b64d63e9f9bc73b79360f07d26e723.png";